import { useFormField } from "uiShadcn/form";
import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "utils/helpers/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    dataTestId: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, dataTestId, required, type, value, ...props }, ref) => {
    const { error } = useFormField();

    return (
        <input
            type={type}
            className={cn(
                "flex w-full rounded-md border border-input bg-background px-n3 py-n4 text-sm ring-offset-background",
                "file:border-0 file:bg-transparent file:font-bold file:text-sm",
                "placeholder:text-muted-foreground",
                "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                "disabled:cursor-not-allowed disabled:opacity-50",
                {
                    "border-destructive focus-visible:ring-destructive": !!error,
                },
                className,
            )}
            data-test-id={dataTestId}
            ref={ref}
            required={required}
            aria-required={required}
            {...(type !== "file" && { value: value ?? "" })}
            {...props}
        />
    );
});
Input.displayName = Input.name;

export { Input };
